import React,{useState} from 'react'
import {Bar} from 'react-chartjs-2'
import {Chart as ChartJS} from 'chart.js/auto'
function BarChartForSaleForTrade({spendPerWeek,spendPerDay}) {
 const [chartData,setChartData]=useState({
    labels: spendPerWeek.map((data)=>data.DateSaved),
    datasets:[{label: "ForTradeValue",
data: spendPerWeek.map((data)=>data.TotalForTrade),
backgroundColor:["blue"],
},{label: "ForSaleValue",
data: spendPerWeek.map((data)=>data.TotalForSale),
backgroundColor:["green"],
},
],
 });
 
 
    return <Bar data={chartData}/>
  
}

export default BarChartForSaleForTrade